var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","fab":"","elevation":"0","color":_vm.$vuetify.theme.isDark ? '#1E1E1E' : 'white'},on:{"click":_vm.locateMusic}},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v("mdi-adjust")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }